import React from "react"
import { useLocalStorage } from "../utils/use-local-storage"
import { DownIcon, UpIcon } from "src/components/icons-svg"

export default function NumericCard({
  topIsSquare = false,
  children,
  number,
  title,
  id,
}) {
  var [isOpened, set_isOpened] = useLocalStorage("card-opened-" + id, true)

  function toggleCard() {
    set_isOpened(!isOpened)
  }

  return (
    <div
      style={{
        borderRadius: `${topIsSquare ? 0 : 11}px ${
          topIsSquare ? 0 : 11
        }px 11px 11px`,
        background: "#FFF",
        padding: "16px 24px 16px 16px",
        display: "flex",
        boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      <table cellSpacing={0} cellPadding={0} width="100%">
        <tr onClick={toggleCard}>
          <td>
            <div
              style={{
                padding: "10px",
                clipPath: "circle(40%)",
                backgroundColor: "#D2D2D2",
                border: "1px solid #D9D9D9",
                color: "black",
                marginRight: "10px",
                fontSize: "18px",
                textAlign: "center",
              }}
            >
              {number}
            </div>
          </td>
          <td valign="middle" width="100%">
            <div
              style={{
                fontSize: "21px",
                fontWeight: 300,
              }}
              dangerouslySetInnerHTML={{ __html: String(title) }}
            />
          </td>
          <td style={{ textAlign: "right", paddingRight: "10px" }}>
            {isOpened ? (
              <span style={{ fontSize: "24px" }}>{DownIcon()}</span>
            ) : (
              <span style={{ fontSize: "24px" }}>{UpIcon()}</span>
            )}
          </td>
        </tr>
        {isOpened && (
          <tr>
            <td></td>
            <td colSpan="2">{children}</td>
          </tr>
        )}
      </table>
    </div>
  )
}
